export const CAPACITY_VALUES: number[] = [1, 2, 5, 10, 25, 50];
